import React from 'react';
import { Github, Linkedin, Code2, LineChart } from 'lucide-react';

function About() {
  const developers = [
    {
      name: 'Rayaan Khan',
      degree: 'Computer Science',
      role: 'Developer',
      about: 'I worked on the frontend and the search functionality for WLUMAPS.',
      linkedin: 'https://www.linkedin.com/in/rayaan-k/',
      github: 'https://github.com/Rayaan-khan428',
      image: 'Rayaan.jpeg'
    },
    {
      name: 'Umar Rasool',
      degree: 'Computer Science',
      role: 'Developer',
      about: 'My role was to work on the backend and database.',
      linkedin: 'https://www.linkedin.com/in/umarrasool',
      github: 'https://github.com/umarrasool15',
      image: '/Umar.jpeg'
    },
    {
      name: 'Shahmeer Shahab',
      degree: 'AFM',
      role: 'Developer',
      about: 'I worked on the business logic and features for WLUMAPS.',
      linkedin: 'https://www.linkedin.com/in/shahmeershahab',
      image: '/Shah.jpg',
    },
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] pt-24 pb-12">
      {/* Hero Section */}
      <div className="relative mb-20">
        <div className="relative max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white">
            About <span className="text-purple-400">WLUMAPS</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed">
            Revolutionizing how Laurier students discover and utilize campus spaces.
          </p>
        </div>
      </div>

      {/* Mission & Vision Section */}
      <div className="max-w-6xl mx-auto px-4 mb-24">
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-[#111] rounded-2xl p-8 border border-white/10 hover:border-purple-500/30 transition-all duration-300">
            <h2 className="text-2xl font-bold mb-4 text-white">
              Our Mission
            </h2>
            <p className="text-lg text-gray-400 leading-relaxed">
              Helping you find the perfect study spot, effortlessly. We want students to spend more time focused on learning and less time searching for where to do it.
            </p>
          </div>
          
          <div className="bg-[#111] rounded-2xl p-8 border border-white/10 hover:border-purple-500/30 transition-all duration-300">
            <h2 className="text-2xl font-bold mb-4 text-white">
              Our Story
            </h2>
            <p className="text-lg text-gray-400 leading-relaxed">
              We know how much it sucks trying to find study spaces on campus during peak hours. That's why we decided to create WLUMAPS to help improve the student experience at Laurier.
            </p>
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-16 text-white">
          Meet Our Team
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {developers.map((dev, index) => (
            <div
              key={index}
              className="bg-[#111] rounded-2xl border border-white/10 hover:border-purple-500/30 transition-all duration-300 p-8 flex flex-col"
            >
              <div className="mb-4">
                <h3 className="text-2xl font-bold text-white mb-1">{dev.name}</h3>
                <div className="flex items-center gap-2 text-purple-300 text-sm font-medium">
                  {dev.degree.includes('Computer Science') ? <Code2 size={16} /> : <LineChart size={16} />}
                  {dev.degree}
                </div>
              </div>

              {dev.about && (
                <p className="text-gray-400 text-sm leading-relaxed flex-1 mb-6">{dev.about}</p>
              )}

              <div className="flex gap-3">
                <a
                  href={dev.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 flex justify-center items-center py-2.5 px-4 bg-white/5 hover:bg-white/10 text-gray-300 hover:text-white rounded-xl border border-white/10 transition-colors"
                >
                  <Linkedin size={20} />
                </a>
                {dev.github && (
                  <a
                    href={dev.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 flex justify-center items-center py-2.5 px-4 bg-white/5 hover:bg-white/10 text-gray-300 hover:text-white rounded-xl border border-white/10 transition-colors"
                  >
                    <Github size={20} />
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default About;